// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.change-password-container {
  max-width: 400px;
  margin: 50px auto;
  padding: 30px;
  border-radius: 12px;
  background: #f9f9f9;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

h2 {
  text-align: center;
  margin-bottom: 20px;
  color: #fdfdfd;
}

.form-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.input-field {
  padding: 12px 15px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 16px;
}

.input-field:focus {
  border-color: #007bff;
  outline: none;
}

.submit-btn {
  padding: 12px;
  border: none;
  background-color: #facc15;
  color: #fff;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.3s;
}

.submit-btn:hover {
  background-color: #0056b3;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Settings/ChangePassword/ChangePassword.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".change-password-container {\n  max-width: 400px;\n  margin: 50px auto;\n  padding: 30px;\n  border-radius: 12px;\n  background: #f9f9f9;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.1);\n}\n\nh2 {\n  text-align: center;\n  margin-bottom: 20px;\n  color: #fdfdfd;\n}\n\n.form-container {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.input-field {\n  padding: 12px 15px;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n  font-size: 16px;\n}\n\n.input-field:focus {\n  border-color: #007bff;\n  outline: none;\n}\n\n.submit-btn {\n  padding: 12px;\n  border: none;\n  background-color: #facc15;\n  color: #fff;\n  font-weight: bold;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: 0.3s;\n}\n\n.submit-btn:hover {\n  background-color: #0056b3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
